import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';

const apiUrl = GlobalConstants.apiURL;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

    constructor(private http:HttpClient, private sharedapi:SharedService) { }

    login(data) {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'login',data,{headers:webheader})
    }

    forgot(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'forgot-password',data,{headers:webheader})
    }

    forgetUserPassword(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'forgot-user-password',data,{headers:webheader})
    }

    resetUserPassword(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'reset-user-password', data, {headers:webheader})
    }

    resendOtp()
    {
        let webheader = this.sharedapi.getHeaders();
        let body = { user_id:localStorage.getItem('resetId')};
        return this.http.post(apiUrl+'resend-code',body,{headers:webheader});
    }

    checkverified(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'verify',data,{headers:webheader});
    }

    isloggedin()
    {
        if(localStorage.getItem('currentUser'))
        {
           return true;
        }else{
            return false;
        }
    }

    resetPassword(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'reset-password',data,{headers:webheader})
    }

    verifychk()
    {
        if(localStorage.getItem('uemail'))
        {
            return true;
        }else{
            return false;
        }
    }

    logout()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'logout',{headers:webheader});
    }

    checkpasswordstatus()
    {
        if(localStorage.getItem('passwordstatus') && localStorage.getItem('passwordstatus')=='1')
        {
            return true;
        }else{
            return false;
        }
    }

    checkappVersion()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(GlobalConstants.openApiURL+'check-app-version/0.0.7',{headers:webheader});
    }
}
